<div class="fieldset-wrapper" style="position: static;"
  [ngClass]="(questions?.mandatory && (isMandatoryUpfront || questions?.isMandatoryStar)) || (questions?.mandatory && isFormSubmit && questions.isMandatoryInvalid) ? 'isMandatory' : ''">

  <div *ngIf="questions.group_no == 0 && questions?.QuestionImageAndMedia_1 != null && !questions?.isCQHide"
    class="questionImageWrapper" [ngClass]="{'question-border': !isMobile}">
    <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_1"
      [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>

  <fieldset [attr.aria-required]="isAriaRequired">
    <!-- <legend Class="question-option-wrapper" [ngClass]="isGrid ? 'mobile-sub-question' : ''" *ngIf="!isMTB && !isDemographics"> -->
    <legend class="tb-legend" [ngClass]="{'1' :(questions?.mandatory),
  '2':(isMandatoryUpfront)}">
    <!-- <span *ngIf="isPreview && (questions.population_type == 2 || questions.population_type == 5)" class="hidden-question-tooltip-icon" appTooltip [dataContext]="''" [IsButtonPanel]="false" IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0">
      </span>
      <span *ngIf="isDisplayQno" class="question-no">{{questions?.qno}}.</span>
      <span *ngIf="questions.piping && !isGrid "
      [ngClass]="{'question-text 16' : questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,
      'mw-sub-question-text': isGrid,
      'no-Qno': !isDisplayQno}"
        id="lbltitle_R{{questions?.UniqueNumber}}">
        <span *ngIf="isDisplaySubQno; else NonDisplaySubQno" class="question-no">{{questions?.subQnoinChar}}</span>
        <ng-template #NonDisplaySubQno>
          <span style="display: none;"></span>
        </ng-template>
        <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        <span *ngIf="questions?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
      </span>
      <span *ngIf="!questions.piping || isGrid"
      [ngClass]="{'question-text 17' : questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,
      'mw-sub-question-text': isGrid,
      'no-Qno': !isDisplayQno && !isGrid,
      'no-subQno':!isDisplaySubQno} "
        id="lbltitle_R{{questions?.UniqueNumber}}">
        <span *ngIf="!isDemographics && isDisplaySubQno; else NonDisplaySubQno" style="display: inline-block;" [innerHTML]="questions?.subQnoinChar | headerFooterHtml"></span>
        <ng-template #NonDisplaySubQno>
          <span style="display: none;"></span>
        </ng-template>
        <ng-container *ngIf="questions.piping && isGrid;else NormalTitle">
          <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        </ng-container>
        <ng-template #NormalTitle>
          <span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
        </ng-template>
        <span *ngIf="questions?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
          <div *ngIf="questions?.hasMedia && !isOtherControl && questions?.MediaText != null && questions?.MediaText != ''" class="question-media-text">
            <span>[{{questions?.MediaText}}]</span>
          </div>
      </span>
      <span *ngIf="isAriaRequired && (isMobile || isGrid)" class="screen-reader-only">This Question is Required</span> -->
    </legend>
    <div Class="question-option-wrapper" [ngClass]="{'mobile-sub-question': isGrid, 'question-border': questions.QuestionImageAndMedia_1 == null && !isMobile && !isGrid}" *ngIf="!isMTB && !isDemographics">
      <span *ngIf="isPreview && (questions.population_type == 2 || questions.population_type == 5)" class="hidden-question-tooltip-icon" appTooltip [dataContext]="''" [IsButtonPanel]="false" IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0">
      </span>
      <span *ngIf="isDisplayQno" class="question-no">{{questions?.qno}}.</span>
      <span *ngIf="questions.piping && !isGrid "
      [ngClass]="{'question-text 16' : questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,
      'mw-sub-question-text': isGrid,
      'no-Qno': !isDisplayQno}"
        id="lbltitle_R{{questions?.UniqueNumber}}">
        <!-- <span *ngIf="isDisplayQno" class="question-no">{{questions?.qno}}.</span> -->
        <span *ngIf="isDisplaySubQno; else NonDisplaySubQno" class="question-no">{{questions?.subQnoinChar}}</span>
        <ng-template #NonDisplaySubQno>
          <span style="display: none;"></span>
        </ng-template>
        <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        <span *ngIf="questions?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
      </span>
      <span *ngIf="!questions.piping || isGrid"
      [ngClass]="{'question-text 17' : questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,
      'mw-sub-question-text': isGrid,
      'no-Qno': !isDisplayQno && !isGrid,
      'no-subQno':!isDisplaySubQno} "
        id="lbltitle_R{{questions?.UniqueNumber}}">
        <span *ngIf="!isDemographics && isDisplaySubQno; else NonDisplaySubQno" style="display: inline-block;" [innerHTML]="questions?.subQnoinChar | headerFooterHtml"></span>
        <ng-template #NonDisplaySubQno>
          <span style="display: none;"></span>
        </ng-template>
        <ng-container *ngIf="questions.piping && isGrid;else NormalTitle">
          <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        </ng-container>
        <ng-template #NormalTitle>
          <span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
        </ng-template>
        <span *ngIf="questions?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
          <div *ngIf="questions?.hasMedia && !isOtherControl && questions?.MediaText != null && questions?.MediaText != ''" class="question-media-text">
            <span>[{{questions?.MediaText}}]</span>
          </div>
      </span>
      <span *ngIf="isAriaRequired && (isMobile || isGrid)" class="screen-reader-only">This Question is Required</span>
    </div>
    <div Class="question-option-wrapper " 
    [ngClass]="{'mobile-sub-question' : isGrid,
     'subqtn':!isGrid,
     'showChar':questions?.Showcharlimit}" 
    
    *ngIf="isMTB && !isDemographics && ((questions?.pipingQuationTitle !='' && questions.piping) ||(questions?.qtitle !='' && !questions.piping)
    ||isDisplaySubQno||((questions?.mandatory || isAnySubQMandatory) && isMandatoryUpfront)||questions?.MTBTitleLocation==1)">
      <span *ngIf="isPreview && (questions.population_type == 2 || questions.population_type == 5)" class="hidden-question-tooltip-icon hdn-mtb" appTooltip [dataContext]="''" [IsButtonPanel]="false" IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0"></span>
      <span *ngIf="isDisplayQno" class="question-no">{{questions?.qno}}.</span>
      <span *ngIf="isDisplaySubQno; else NonDisplaySubQno" class="question-no">{{questions?.subQnoinChar}}</span>
      <ng-template #NonDisplaySubQno>
        <span style="display: none;"></span>
      </ng-template>
      <span *ngIf="questions.piping && !isGrid"
      [ngClass]="{'question-text 11' : questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,'no-Qno':!isDisplayQno}" id="lbltitle_R{{questions?.UniqueNumber}}">
        <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml" class="question-text-span"></span>
        <span *ngIf="questions?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
        [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
        <span *ngIf="isAriaRequired" class="screen-reader-only">This Question is Required</span>
      </span>
      <span *ngIf="!questions.piping || isGrid"
      [ngClass]="{'question-text 1' : questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,
      'mw-sub-question-text': isGrid,
      'no-subQno':!isDisplaySubQno}"
       id="lbltitle_R{{questions?.UniqueNumber}}">
        <span [innerHTML]="questions?.qtitle | headerFooterHtml" class="question-text-span"></span>
        <span *ngIf="questions?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
        [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
        <span *ngIf="isAriaRequired" class="screen-reader-only">This Question is Required</span>
      </span>

    </div>

    <div Class="question-option-wrapper" *ngIf="isDemographics && !isMTB">
      <span *ngIf="isPreview && (questions.population_type == 2 || questions.population_type == 5)" class="hidden-question-tooltip-icon hdn-demo" appTooltip [dataContext]="''" [IsButtonPanel]="false" IsAnswerToolTip="true" IsHiddenQToolTip="true" tabindex="0"></span>
      <span *ngIf="isDisplayQno" class="question-no 1">{{questions?.qno}}.</span>
      <span *ngIf="isDisplaySubQno" class="question-no 2">{{questions?.subQnoinChar}}</span>
      <span *ngIf="questions.piping && !isGrid"
      [ngClass]="{'question-text 12' : questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,
      'mw-sub-question-text': isGrid,'no-Qno 4':!isDisplayQno}"
        id="lbltitle_R{{questions?.UniqueNumber}}">
        <span [innerHTML]="questions?.pipingQuationTitle | headerFooterHtml"></span>
        <span *ngIf="questions?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
          <span *ngIf="isAriaRequired" class="screen-reader-only">This Question is Required</span>
      </span>
      <span *ngIf="!questions.piping || isGrid "
      [ngClass]="{'question-text 13' : questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,
      'mw-sub-question-text': isGrid,
      'no-subQno':!isDisplaySubQno}"
        id="lbltitle_R{{questions?.UniqueNumber}}">
        <span *ngIf="!isDemographics" [innerHTML]="questions?.subQnoinChar | headerFooterHtml"></span>
        <span [innerHTML]="questions?.qtitle | headerFooterHtml"></span>
        <span *ngIf="questions?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="questions?.QuestionTip"
          [IsButtonPanel]="false" [qid]="questions?.UniqueNumber" tabindex="0" ></span>
          <div *ngIf="questions?.hasMedia && !isOtherControl" class="question-media-text">
            <span>[{{questions?.MediaText}}]</span>
          </div>
          <span *ngIf="isAriaRequired" class="screen-reader-only">This Question is Required</span>
      </span>

    </div>

    <div *ngIf="questions.group_no == 0 && questions?.QuestionImageAndMedia_2 != null && !questions?.isCQHide"
      class="questionImageWrapper">
      <app-question-image-and-media [questionImageAndMedias]="questions?.QuestionImageAndMedia_2"
        [imageSize]="questions?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>

    <div class="answer-option-wrapper tb-box"
    [ngStyle]="{'z-index': (questions?.qsubtype == 1 || questions?.qsubtype == 2 || questions?.qsubtype == 3 || questions?.qsubtype == 4) ? '1' : ''}">
      <div *ngIf="questions?.qsubtype == 0; else Attachment">
          <div *ngIf="questions?.population_type != 3; else Textpopulation"  [ngStyle]="{'max-width': isMTB && questions?.tHeight > 1 ? '500px': ''}">
        <div *ngIf="questions?.tHeight == 0 || questions?.tHeight == 1; else TextAreaControl">
          <div *ngIf="questions?.population_type != 1; else Preeditpopulation" [ngStyle]="{'max-width': isMTB ? '500px': ''}">
            <input type="text" [style.width]="textBoxWidth" class="ansopt-textbox" (blur)="onBlurMethod()"
              id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID"
              name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText"
              (keyup)="questions.Showcharlimit || isNewParticipation ? keytab_remainingChar($event, $event.target.value) : ''" [disabled]="questions?.IsDisabled"
              maxlength="{{questions?.characterLimit ? questions?.characterLimit: ''}}"
              attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}}" (click)="clickEvent($event)">
          </div>
          <ng-template #Preeditpopulation>
            <input type="text" [style.width]="textBoxWidth" class="ansopt-textbox" (blur)="onBlurMethod()"
              id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID"
              name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText"
              (keyup)="questions.Showcharlimit || isNewParticipation ? keytab_remainingChar($event, $event.target.value): ''"
              maxlength="{{questions?.characterLimit ? questions?.characterLimit: ''}}"
              attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}}">
          </ng-template>
        </div>
        <ng-template #TextAreaControl>
          <textarea style="box-sizing: border-box" rows="{{questions?.tHeight}}" [ngClass]="{'mtb-textarea': isMTB}"
          [style.width]="questions?.twidth +'%'" class="ansopt-textbox" [disabled]="questions?.IsDisabled"
          (blur)="onBlurMethod()" id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID" [ngStyle]="{'max-width': isMTB ? '500px': ''}"
          name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText"
          (keyup)="questions.Showcharlimit || isNewParticipation ? keytab_remainingChar($event, $event.target.value) : ''"
          maxlength="{{questions?.characterLimit ? questions?.characterLimit: ''}}"  (click)="clickEvent($event)"></textarea>
        </ng-template>
        <div *ngIf="questions?.Showcharlimit" class="char-remain charraim">
          {{getRemainingChar()}}: {{remainingCharacters}}
        </div>
        </div>
        <ng-template #Textpopulation>
          <ng-container *ngIf="setURLPrePopText(questions.PrePopText) != null; else NormalPrePopText">
            <span class="answer-text read-only" [innerHTML]="setURLPrePopText(questions.PrePopText) | headerFooterHtml"></span>
          </ng-container>
          <ng-template #NormalPrePopText>
            <span class="answer-text read-only">{{questions.PrePopText}}</span>
          </ng-template>
        </ng-template>
      </div>
      <ng-template #Attachment>
          <div *ngIf="questions?.population_type != 3; else AttachmentTextpopulation">
        <div *ngIf="questions?.qsubtype == 71; else OtherValidation" class="attach-tb">
          <div *ngIf="questions?.tHeight == 0 || questions?.tHeight == 1" >
            <input type="text" class="ansopt-textbox" (blur)="onBlurMethod()"
              id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID"
              name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText"
              (keyup)="questions.Showcharlimit ? keytab_remainingChar($event, $event.target.value) : ''"
              maxlength="{{questions?.characterLimit ? questions?.characterLimit: ''}}"
              attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}}"
              [disabled]="true"
              [ngClass]="{'red-zone':questions.isValid}"
              [ngStyle]="{'float': isrtl? 'right' : 'left', 'max-width': isMobile? '150px' : '230px'}">
              <div [ngStyle]="{'float': isrtl? 'right' : 'left'}">

                <a class="common-icon delete-icon-light"
                id="lnkRemove_{{questions?.UniqueNumber}}" href="javascript:void(0)"
                style="position: relative; display: none; font-size: small; visibility: hidden;"
                (click)="deleteFile();" *ngIf="isrtl"></a>

                <div class="attachedLoader" [ngClass]="(isrtl) ? 'fl': ''" id="loader_{{questions?.UniqueNumber}}" style="display: none;"><div><div class="line" style="width: 3.33333px; height: 10px; margin: 3.33333px; border-radius: 3.33333px;"></div><div class="line" style="width: 3.33333px; height: 10px; margin: 3.33333px; border-radius: 3.33333px;"></div><div class="line" style="width: 3.33333px; height: 10px; margin: 3.33333px; border-radius: 3.33333px;"></div></div></div>

                <div style="position: relative;display: block;overflow: hidden;float: left;" [ngStyle]="{'margin': isrtl? '2px 10px 0 0' : '2px 0 0 10px', 'margin-top': isMobile? '5px' : '2px'}">
                  <span class="desktopfile-icon">
                    <input attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}} lblalert_{{questions?.UniqueNumber}}"
                    type="button" id="btnBrowse_{{questions?.UniqueNumber}}" class="browse-btn-class"
                    style="height:30px;text-align:center;" (keydown)="uploadFile($event)" (click)="uploadFileclick();"
                    [attr.aria-required]="isAriaRequired">
                  </span>
                  <input class="attach-file-btn" tabindex="-1" type="file" (change)="handleFileInput($event.target.files, $event)" id="File_{{questions?.qno}}_{{questions?.UniqueNumber}}" name="File_{{questions?.qno}}_{{questions?.UniqueNumber}}" aria-label="file" aria-hidden="true">
                </div>

                <a class="common-icon delete-icon-light"
                id="lnkRemove_{{questions?.UniqueNumber}}" href="javascript:void(0)"
                style="position: relative; display: none; font-size: small; visibility: hidden;"
                (click)="deleteFile();" *ngIf="!isrtl"></a>

              </div>
          </div>
          <div *ngIf="questions.isValid" class="validator_message" role="alert" id="lblalert_{{questions?.UniqueNumber}}">
            {{questions.error_msg}}
          </div>
        </div>
      <ng-template #OtherValidation>
        <!-- Date Part Validation -->
        <div class="calendar-qtn notranslate"
          *ngIf="questions?.qsubtype == 1 || questions?.qsubtype == 2 || questions?.qsubtype == 3 || questions?.qsubtype == 4; else OtherThanDateValidation">
          <div *ngIf="questions?.qsubtype == 1 || (isMobile && questions?.qsubtype == 3)" class="date-picker-cont" style="position: static;">
              <span *ngIf="questions?.population_type != 1; else DatePreeditpopulation">
                  <input type="text" [style.width]="questions?.twidth +'%'" class="ansopt-textbox form-control txtDate"
                  (blur)="ValidationForSubQuestionType($event, $event.target.value)"
                  id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID"
                  name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText" (keyup)="keyup()"
                  maxlength="{{questions?.characterLimit ? questions?.characterLimit: ''}}" autocomplete="off"
                  attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}} lblalert_{{questions?.UniqueNumber}}"
                  attr.aria-describedby="Please Enter Date In Format mm/dd/yyyy"
                  [ngClass]="{'red-zone':questions.isValid}">
              </span>
              <ng-template #DatePreeditpopulation>
                  <input type="text" [style.width]="questions?.twidth +'%'" class="ansopt-textbox form-control txtDate"
                  (blur)="ValidationForSubQuestionType($event, $event.target.value)"
                  id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID"
                  name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText" (keyup)="keyup()"
                  maxlength="{{questions?.characterLimit ? questions?.characterLimit: ''}}" autocomplete="off"
                  attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}} lblalert_{{questions?.UniqueNumber}}"
                  attr.aria-describedby="Please Enter Date In Format mm/dd/yyyy"
                  [ngClass]="{'red-zone':questions.isValid}"
                  >
              </ng-template>

            <div *ngIf="questions.isValid" class="validator_message" role="alert" id="lblalert_{{questions?.UniqueNumber}}">
              {{questions.error_msg}}
            </div>
            <div *ngIf="questions.isValid" class="validator_message" role="alert" id="lblalert_{{questions?.UniqueNumber}}">
              {{questions?.error_msg}}
            </div>
            <span class='dtpOpener'>
              <svg version="1.1" id="Layer_1_SVG{{questions?.qno}}_{{questions?.UniqueNumber}}" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px"
                viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
                <path class="svgpath"
                  d="M9.7,12.7c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3H7c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h1V8.5L7.2,9.2c-0.1,0.1-0.3,0.1-0.5,0c-0.1-0.1-0.1-0.3,0-0.5l1.3-1.3c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0.1,0.2,0.2,0.2,0.3v5 M0,15.7C0,15.9,0.1,16,0.3,16h15.3c0.2,0,0.3-0.1,0.3-0.3V5.3H0V15.7z">
                </path>
                <path class="svgpath"
                  d="M12.7,2.7h-1.3v-2h1.3V2.7z M4.7,2.7H3.3v-2h1.3V2.7z M15.7,1.3h-2.3v-1C13.3,0.1,13.2,0,13,0h-2c-0.2,0-0.3,0.1-0.3,0.3v1H5.3v-1C5.3,0.1,5.2,0,5,0H3C2.8,0,2.7,0.1,2.7,0.3v1H0.3C0.1,1.3,0,1.5,0,1.7v3h16v-3C16,1.5,15.9,1.3,15.7,1.3">
                </path>
              </svg>
            </span>
            <span class="date-format-text" id="date-format-text-{{questions.UniqueNumber}}">[mm/dd/yyyy]</span>
            <div class="dtpContainer" dir="ltr">
              <div class="dtp">
              </div>
            </div>
          </div>

          <div *ngIf="questions?.qsubtype == 2 || (isMobile && questions?.qsubtype == 4)" class="date-picker-cont" style="position: static;">
            <input type="text" [style.width]="questions?.twidth +'%'" class="ansopt-textbox txtDate"
              (blur)="ValidationForSubQuestionType($event, $event.target.value)"
              id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID"
              name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText" (keyup)="keyup()"
              maxlength="{{questions?.characterLimit ? questions?.characterLimit: ''}}" autocomplete="off"
              attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}} lblalert_{{questions?.UniqueNumber}}"
              aria-describedby="Please Enter Date In Format dd/mm/yyyy"
              [ngClass]="{'red-zone':questions.isValid}">
            <div *ngIf="questions.isValid" class="validator_message" role="alert" id="lblalert_{{questions?.UniqueNumber}}">
              {{questions.error_msg}}
            </div>
            <span class='dtpOpener'>
              <svg version="1.1" id="Layer_1_SVG{{questions?.qno}}_{{questions?.UniqueNumber}}" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px"
                viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
                <path class="svgpath"
                  d="M9.7,12.7c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3H7c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h1V8.5L7.2,9.2c-0.1,0.1-0.3,0.1-0.5,0c-0.1-0.1-0.1-0.3,0-0.5l1.3-1.3c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0.1,0.2,0.2,0.2,0.3v5 M0,15.7C0,15.9,0.1,16,0.3,16h15.3c0.2,0,0.3-0.1,0.3-0.3V5.3H0V15.7z">
                </path>
                <path class="svgpath"
                  d="M12.7,2.7h-1.3v-2h1.3V2.7z M4.7,2.7H3.3v-2h1.3V2.7z M15.7,1.3h-2.3v-1C13.3,0.1,13.2,0,13,0h-2c-0.2,0-0.3,0.1-0.3,0.3v1H5.3v-1C5.3,0.1,5.2,0,5,0H3C2.8,0,2.7,0.1,2.7,0.3v1H0.3C0.1,1.3,0,1.5,0,1.7v3h16v-3C16,1.5,15.9,1.3,15.7,1.3">
                </path>
              </svg>
            </span>
            <span class="date-format-text" id="date-format-text-{{questions.UniqueNumber}}">[dd/mm/yyyy]</span>
            <div class="dtpContainer" dir="ltr">
              <div class="dtp">
              </div>
            </div>
          </div>
          <div *ngIf=" questions?.qsubtype == 3 && !isMobile" class="date-picker-cont" style="position: static;">
            <div class="custom-select-wrapper">
              <div class="arr">
                <div class="arr-symbol"></div>
              </div>
              <select id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_month"
                (change)="pupulate('_month');SelectedValue($event)"
                name="entry[Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_month]" [(ngModel)]="SelectedMonth"
                aria-label="Month">
              </select>
            </div>
            <div class="custom-select-wrapper">
              <div class="arr">
                <div class="arr-symbol"></div>
              </div>
              <select id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_day"
                (change)="pupulate('_day');SelectedValue($event)"
                name="entry[Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_day]" [(ngModel)]="SelectedDate"
                aria-label="Day">
              </select>
            </div>
            <div class="custom-select-wrapper">
              <div class="arr">
                <div class="arr-symbol"></div>
              </div>
              <select id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_year"
                name="entry[Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_year]"
                (change)="pupulate('_year');SelectedValue($event)" [(ngModel)]="selectedYear"
                aria-label="Year">
              </select>
            </div>
            <input type="hidden" id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID" [(ngModel)]="setDateText" />
            <span class='dtpOpener'>
              <svg version="1.1" id="Layer_1_SVG{{questions?.qno}}_{{questions?.UniqueNumber}}" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px"
                viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
                <path class="svgpath"
                  d="M9.7,12.7c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3H7c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h1V8.5L7.2,9.2c-0.1,0.1-0.3,0.1-0.5,0c-0.1-0.1-0.1-0.3,0-0.5l1.3-1.3c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0.1,0.2,0.2,0.2,0.3v5 M0,15.7C0,15.9,0.1,16,0.3,16h15.3c0.2,0,0.3-0.1,0.3-0.3V5.3H0V15.7z">
                </path>
                <path class="svgpath"
                  d="M12.7,2.7h-1.3v-2h1.3V2.7z M4.7,2.7H3.3v-2h1.3V2.7z M15.7,1.3h-2.3v-1C13.3,0.1,13.2,0,13,0h-2c-0.2,0-0.3,0.1-0.3,0.3v1H5.3v-1C5.3,0.1,5.2,0,5,0H3C2.8,0,2.7,0.1,2.7,0.3v1H0.3C0.1,1.3,0,1.5,0,1.7v3h16v-3C16,1.5,15.9,1.3,15.7,1.3">
                </path>
              </svg>
            </span>
            <div class="dtpContainer" dir="ltr">
              <div class="dtp">
              </div>
            </div>
          </div>

          <div *ngIf="questions?.qsubtype == 4 && !isMobile" class="date-picker-cont" style="position: static;">

            <div class="custom-select-wrapper">
              <div class="arr">
                <div class="arr-symbol"></div>
              </div>
              <select id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_day"
                name="entry[Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_day]"
                (change)="pupulate('_day');SelectedValue($event)" [(ngModel)]="SelectedDate"
                aria-label="Day">
              </select>
            </div>
            <div class="custom-select-wrapper">
              <div class="arr">
                <div class="arr-symbol"></div>
              </div>
              <select id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_month"
                name="entry[Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_month]"
                (change)="pupulate('_month');SelectedValue($event)" [(ngModel)]="SelectedMonth"
                aria-label="Month">
              </select>
            </div>
            <div class="custom-select-wrapper">
              <div class="arr">
                <div class="arr-symbol"></div>
              </div>
              <select id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_year"
                name="entry[Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_year]"
                (change)="pupulate('_year');SelectedValue($event)" [(ngModel)]="selectedYear"
                aria-label="Year">
              </select>
            </div>
            <input type="hidden" id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID" [(ngModel)]="setDateText" />
            <span class='dtpOpener'>
              <svg version="1.1" id="Layer_1_SVG{{questions?.qno}}_{{questions?.UniqueNumber}}" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px"
                viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve">
                <path class="svgpath"
                  d="M9.7,12.7c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3H7c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h1V8.5L7.2,9.2c-0.1,0.1-0.3,0.1-0.5,0c-0.1-0.1-0.1-0.3,0-0.5l1.3-1.3c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0.1,0.2,0.2,0.2,0.3v5 M0,15.7C0,15.9,0.1,16,0.3,16h15.3c0.2,0,0.3-0.1,0.3-0.3V5.3H0V15.7z">
                </path>
                <path class="svgpath"
                  d="M12.7,2.7h-1.3v-2h1.3V2.7z M4.7,2.7H3.3v-2h1.3V2.7z M15.7,1.3h-2.3v-1C13.3,0.1,13.2,0,13,0h-2c-0.2,0-0.3,0.1-0.3,0.3v1H5.3v-1C5.3,0.1,5.2,0,5,0H3C2.8,0,2.7,0.1,2.7,0.3v1H0.3C0.1,1.3,0,1.5,0,1.7v3h16v-3C16,1.5,15.9,1.3,15.7,1.3">
                </path>
              </svg>
            </span>
            <div class="dtpContainer" dir="ltr">
              <div class="dtp">
              </div>
            </div>
          </div>
        </div>

        <ng-template #OtherThanDateValidation>
          <div class="form-group" [ngClass]="{spclCharMobile: ((questions?.apply_currency == 1 || questions?.append_percentage == 1) && isMobile)}">
            <span *ngIf="questions?.qsubtype == 22 && questions?.apply_currency == 1" class="spcl-char currencySymbol">{{questions.currency_Symbol}}</span>
            <ng-container *ngIf="questions.qsubtype != 63; else InternationalPhoneNumber">
              <ng-container *ngIf="questions?.tHeight == 0 || questions?.tHeight == 1; else TextAreaControl">
                <span *ngIf="questions?.population_type != 1; else OtherPreeditpopulation">
                  <span *ngIf="questions.qsubtype == 21">

                    <ng-container *ngIf="isMobile || isGrid;else Desktop">
                      <input type="tel" pattern="[0-9]*" inputmode="decimal" id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID"
                      [disabled]="questions?.IsDisabled" [style.width]="textBoxWidth" class="ansopt-textbox" [placeholder]="''"
                      [ngClass]="{
                        'number' : questions.qsubtype == 21 && !isMobile,
                        'red-zone' : questions.isValid}"
                      (blur)="ValidationForSubQuestionType($event, $event.target.value)"
                      name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText"
                      #valid="ngModel" attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}} lblalert_{{questions?.UniqueNumber}}"
                      (click)="clickEvent($event)" (keydown)="keyDown($event)"
                      [ngStyle]="{ 'max-width': '' }"/>
                    </ng-container>
                    <ng-template #Desktop>
                      <input type="text" pattern="[0-9]*" inputmode="decimal"
                        id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID" [disabled]="questions?.IsDisabled"
                        [style.width]="textBoxWidth" class="ansopt-textbox" [placeholder]="''"
                         [ngClass]="{'number' : questions.qsubtype == 21 && !isMobile,'red-zone' : questions.isValid}"
                        (blur)="ValidationForSubQuestionType($event, $event.target.value)"
                        name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText"
                        #valid="ngModel"
                        attr.aria.describedby="test"
                        attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}}"
                        (click)="clickEvent($event)" (keydown)="keyDown($event)" [ngStyle]="{ 'max-width': '' }" />
                        <!-- lblalert_{{questions?.UniqueNumber}} -->
                    </ng-template>
                  </span>
                  <span *ngIf="questions.qsubtype != 21">
                    <input type="text" id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID"
                    minlength="{{questions?.num_range_1 ? questions?.num_range_1: ''}}" [disabled]="questions?.IsDisabled"
                    maxlength="{{questions?.num_range_2 ? questions?.num_range_2: ''}}"
                    [style.width]="textBoxWidth" class="ansopt-textbox" [placeholder]="questions.qsubtype == 61 ? '(201) 555-0123' : ''"
                    [ngClass]="{'zipcode' : (questions.qsubtype == 11 || questions.qsubtype == 12) && !isMobile,
                                 'number' : questions.qsubtype == 21 && !isMobile,
                                 'currency': questions.qsubtype == 22 && !isMobile,
                                 'ssn': questions.qsubtype == 51 && !isMobile,
                                 'email 1': questions.qsubtype == 31 && !isMobile,
                                 'percentage': questions.qsubtype == 41 && !isMobile,
                                 'phone': questions.qsubtype == 61 && !isMobile,
                                 'red-zone' : questions.isValid} "
                    (blur)="ValidationForSubQuestionType($event, $event.target.value)"
                    name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText"
                    #valid="ngModel" attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}} lblalert_{{questions?.UniqueNumber}}"
                    (click)="clickEvent($event)" (keydown)="keyDown($event)"
                    [ngStyle]="{ 'max-width': questions.qsubtype == 31 && isMTB && !isMobile ? questions.twidth + '%' : '' }"/>
                  </span>

                </span>
                <ng-template #OtherPreeditpopulation>
                  <input type="text" id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID"
                    [style.width]="textBoxWidth" class="ansopt-textbox"
                    [ngClass]="{'zipcode' : (questions.qsubtype == 11 || questions.qsubtype == 12) && !isMobile,
                    'number' : questions.qsubtype == 21 && !isMobile,
                    'currency': questions.qsubtype == 22 && !isMobile,
                    'ssn': questions.qsubtype == 51 && !isMobile,
                    'email': questions.qsubtype == 31 && !isMobile,
                    'percentage': questions.qsubtype == 41 && !isMobile,
                    'phone': questions.qsubtype == 61 && !isMobile,
                    'red-zone' : questions.isValid} "
                    (blur)="ValidationForSubQuestionType($event, $event.target.value)"
                    name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText"
                    #valid="ngModel" attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}} lblalert_{{questions?.UniqueNumber}}"
                    (click)="clickEvent($event)" (keydown)="keyDown($event)"
                    [ngStyle]="{ 'max-width': questions.qsubtype == 31 && isMTB && !isMobile ? questions.twidth + '%' : '' }"/>
                </ng-template>
              </ng-container>
              <ng-template #TextAreaControl>
                <textarea style="box-sizing: border-box" rows="{{questions?.tHeight}}"
                  id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID" [disabled]="questions?.IsDisabled"
                  [style.width]="questions?.twidth +'%'" class="ansopt-textbox"
                  (blur)="ValidationForSubQuestionType($event, $event.target.value)"
                  name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME" [(ngModel)]="questions.AnswerText"
                  [ngClass]="{'zipcode' : (questions.qsubtype == 11 || questions.qsubtype == 12) && !isMobile && isMTB,
                  'number' : questions.qsubtype == 21 && !isMobile && isMTB,
                  'currency': questions.qsubtype == 22 && !isMobile && isMTB,
                  'ssn': questions.qsubtype == 51 && !isMobile && isMTB,
                  'email': questions.qsubtype == 31 && !isMobile && isMTB,
                  'percentage': questions.qsubtype == 41 && !isMobile && isMTB,
                  'phone': questions.qsubtype == 61 && !isMobile && isMTB,
                  'red-zone' : questions.isValid, 'mtb-textarea': isMTB}" [placeholder]="questions.qsubtype == 61 ? '(201) 555-0123' : ''"></textarea>
              </ng-template>
            </ng-container>

            <ng-template #InternationalPhoneNumber>
              <app-telephone [question]="questions" (ChangeAnswersData)="UpdateQuestionsData($event)"></app-telephone>
            </ng-template>

            <span *ngIf="questions?.qsubtype == 41 && questions?.append_percentage == 1" class="spcl-char percentSymbol">%</span>

            <span *ngIf="questions.qsubtype == 10" class="font custm_msg_text">{{questions.Custom_Message}}</span>
          </div>
          <div *ngIf="questions.isValid && questions.qsubtype != 31 && questions.qsubtype != 10" class="validator_message" role="alert" id="lblalert_{{questions?.UniqueNumber}}">
            <ng-container *ngIf="questions.qsubtype == 22 && isNegativeCurrencyValue; else NormalMessage">
             {{getCurrencyMessage()}}
            </ng-container>
            <ng-template #NormalMessage>
              {{questions.error_msg}}
            </ng-template>
          </div>
          <div *ngIf="questions.isValid && questions.qsubtype == 31 && questions.isReEnterEmail"
            class="validator_message" role="alert" id="lblalert_{{questions?.UniqueNumber}}">
            {{questions.error_msg}}
          </div>
          <div *ngIf="questions.isValid && questions.qsubtype == 10"
            class="validator_message" role="alert" id="lblalert_{{questions?.UniqueNumber}}">
            {{questions.error_msg}}
          </div>
          <div *ngIf="questions.qsubtype == 31 && questions.isreenter == 1 && !isDemographics && !isMTB">
            <div Class="reenter">
              <span
              [ngClass]="{'question-text 2' : questions.isOverAllStyleApplied,
              'question-text-nb': !questions.isOverAllStyleApplied,
              'mw-sub-question-text': isGrid}"
               id="lbltitle_T{{questions?.UniqueNumber}}_ReEnter">{{ReenterTextMulti}}</span>
            </div>
            <input type="text" class="ansopt-textbox" [disabled]="questions?.isReEnterEmail"
              id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_ReEnter" autocomplete="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_ReEnter"
              minlength="{{questions?.num_range_1 ? questions?.num_range_1: ''}}"
              maxlength="{{questions?.num_range_2 ? questions?.num_range_2: ''}}" [style.width]="questions?.twidth +'%'"
              (blur)="CompareReEnterEmail($event, $event.target.value)"
              name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME_ReEnter" [(ngModel)]="questions.otherAnswer"
              attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}} lblalert_{{questions?.UniqueNumber}}"
              onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false"
              [ngClass]="{'red-zone':questions?.isReEnterEmailValid}"
              [ngStyle]="{ 'max-width': isMTB && !isMobile ? questions.twidth + '%' : '' }"/>

            <div *ngIf="questions?.isReEnterEmailValid && questions?.otherAnswer != null" class="validator_message" role="alert" id="lblalert_{{questions?.UniqueNumber}}">
              {{questions.reEnterErrMsg}}
            </div>
            <div *ngIf="questions?.isReEnterEmailValid && questions?.otherAnswer == null" class="validator_message" role="alert" id="lblalert_{{questions?.UniqueNumber}}">
              {{ReEnterBlankMessage}}
            </div>
          </div>
        </ng-template>
      </ng-template>
          </div>
          <ng-template #AttachmentTextpopulation>
            <span class="answer-text read-only">{{questions.PrePopText}}</span>
          </ng-template>
      </ng-template>
      <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2) && !this.isDemographics && !this.isMTB">
        <div class="ques-response-btn-div"   >
          <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn" (click)="gotoNextQuestion(questions,$event.target)"/> -->
          <button *ngIf="isAnsChange || questions.population_type ==3 || questions.date_default" type="button" class="ques-response-btn" (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)" (click)="gotoNextQuestion(questions,$event.target)">{{newParticipationBtnText}}</button>
        </div>
      </ng-container>
    </div>
  </fieldset>
</div>
<div class="fieldset-wrapper" style="position: static;" *ngIf="questions.qsubtype == 31  && questions?.population_type != 3 && questions.isreenter == 1 && (isDemographics || isMTB)" >

  <fieldset [attr.aria-required]="isAriaRequired">
    <!-- <legend Class="question-option-wrapper" [ngClass]="isGrid ? 'mobile-sub-question' : ''" *ngIf="!isMTB && !isDemographics"> -->
      <legend class="tb-legend">
      </legend>
      <div Class="question-option-wrapper" [ngClass]="{'mobile-sub-question': isGrid, 'question-border': questions.QuestionImageAndMedia_1 == null && !isMobile && !isGrid}" *ngIf="!isMTB && !isDemographics">
      </div>

    <div Class="question-option-wrapper reenter" [ngClass]="isGrid ? 'mobile-sub-question' : 'subqtn'" *ngIf="isMTB">
      <!-- <span *ngIf="isDisplaySubQno; else NonDisplaySubQno" class="question-no"></span> -->
      <ng-template #NonDisplaySubQno>
        <span style="display: none;"></span>
      </ng-template>
      <span
      [ngClass]="{'question-text 14' : questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,
      'mw-sub-question-text': isGrid,'no-Qno 6':!isDisplayQno}"
       id="lbltitle_R{{questions?.UniqueNumber}}">
       <span>{{ReenterTextMulti}}</span>
        <span *ngIf="isAriaRequired" class="screen-reader-only">This Question is Required</span>
      </span>

    </div>

    <div Class="question-option-wrapper reenter" *ngIf="isDemographics">
      <span
      [ngClass]="{'question-text 15' : questions.isOverAllStyleApplied,
      'question-text-nb': !questions.isOverAllStyleApplied,'no-Qno':!isDisplayQno}"
        id="lbltitle_R{{questions?.UniqueNumber}}">
        <span>{{ReenterTextMulti}}</span>
          <span *ngIf="isAriaRequired" class="screen-reader-only">This Question is Required</span>
      </span>
    </div>
    <div class="answer-option-wrapper tb-box">
    <div *ngIf="questions.qsubtype == 31 && questions.isreenter == 1">
      <input type="text" class="ansopt-textbox reenterEmail" [disabled]="questions?.isReEnterEmail"
        id="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_ReEnter" autocomplete="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_ID_ReEnter"
        minlength="{{questions?.num_range_1 ? questions?.num_range_1: ''}}"
        maxlength="{{questions?.num_range_2 ? questions?.num_range_2: ''}}" [style.width]="questions?.twidth +'%'"
        (blur)="CompareReEnterEmail($event, $event.target.value)"
        name="Q{{questions?.qno}}_{{questions?.UniqueNumber}}_T_NAME_ReEnter" [(ngModel)]="questions.otherAnswer"
        attr.aria-labelledby="lbltitle_R{{questions?.UniqueNumber}} lblalert_{{questions?.UniqueNumber}}"
        onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false"
        [ngClass]="{'red-zone':questions?.isReEnterEmailValid}"
        [ngStyle]="{ 'max-width': isMTB && !isMobile ? questions.twidth + '%' : '' }"/>
      <div *ngIf="questions?.isReEnterEmailValid && questions?.otherAnswer != null" class="validator_message" role="alert" id="lblalert_{{questions?.UniqueNumber}}">
        {{questions.reEnterErrMsg}}
      </div>
      <div *ngIf="questions?.isReEnterEmailValid && questions?.otherAnswer == null" class="validator_message" role="alert" id="lblalert_{{questions?.UniqueNumber}}">
        {{ReEnterBlankMessage}}
      </div>
    </div>
    </div>
  </fieldset>
</div>
